import journalApi from "../../api/journals";
import * as mutationTypes from "../mutation-types";

const state = {
  journals: [],
  journalElasticsearchErrorDetail: "",
  isJournalSearching: false,
  previousQuery: null,
};

const getters = {
  journals: (state) => state.journals,
  journalElasticsearchErrorDetail: (state) => state.journalElasticsearchErrorDetail,
  isJournalSearching: (state) => state.isJournalSearching,
  previousQuery: (state) => state.previousQuery,
};

const actions = {
  elasticsearchJournals({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit(mutationTypes.ASSIGN_IS_JOURNAL_SEARCHING, true);
      journalApi.elasticsearchJournals(
        params,
        (journals) => {
          commit(mutationTypes.ASSIGN_JOURNALS, { journals });
          commit(mutationTypes.ASSIGN_IS_JOURNAL_SEARCHING, false);
          const journalElasticsearchErrorDetail = "";
          commit(mutationTypes.ASSIGN_JOURNAL_ELASTICSEARCH_ERROR_DETAIL, { journalElasticsearchErrorDetail });
          commit(mutationTypes.ASSIGN_PREVIOUS_QUERY, { previousQuery: params });
          resolve();
        },
        (error) => {
          commit(mutationTypes.ASSIGN_IS_JOURNAL_SEARCHING, false);
          const journalElasticsearchErrorDetail = error.response.data["message"];
          commit(mutationTypes.ASSIGN_JOURNAL_ELASTICSEARCH_ERROR_DETAIL, { journalElasticsearchErrorDetail });
          reject();
        }
      );
    });
  },
  clearJournals({ commit }) {
    commit(mutationTypes.ASSIGN_JOURNALS, { journals: [] });
    commit(mutationTypes.ASSIGN_JOURNAL_ELASTICSEARCH_ERROR_DETAIL, { journalElasticsearchErrorDetail: "" });
    commit(mutationTypes.ASSIGN_IS_JOURNAL_SEARCHING, false);
    commit(mutationTypes.ASSIGN_PREVIOUS_QUERY, { previousQuery: null });
  },
};

const mutations = {
  [mutationTypes.ASSIGN_JOURNALS](state, { journals }) {
    state.journals = journals;
  },
  [mutationTypes.ASSIGN_JOURNAL_ELASTICSEARCH_ERROR_DETAIL](state, { journalElasticsearchErrorDetail }) {
    state.journalElasticsearchErrorDetail = journalElasticsearchErrorDetail;
  },
  [mutationTypes.ASSIGN_IS_JOURNAL_SEARCHING](state, isSearching) {
    state.isJournalSearching = isSearching;
  },
  [mutationTypes.ASSIGN_PREVIOUS_QUERY](state, { previousQuery }) {
    state.previousQuery = previousQuery;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
